// detect "Windows" (17px) scrollbar that pushed reduces width of whole page
// "positon: fixed" elements has to be moved to the left accrodingly
if (window.innerWidth - document.querySelector(`[data-scroll-wrapper]`).clientWidth > 0) {
    document.body.classList.add(`has-windows-scrollbar`)
    console.log(`has scrollbar`)
}